import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Chip, IconButton, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import PageTitle from "../../../misc/PageTitle";
import type { ReportDefinition } from "../reportCatalog";
import { tint } from "../reportCatalog";

interface Props {
  readonly report: ReportDefinition;
}

const ReportHeader: FC<Props> = ({ report }) => {
  const Icon = report.icon;
  return (
    <>
      <PageTitle title={report.title} />
      <Stack direction="row" spacing={2} sx={{ mb: 3, alignItems: "center" }}>
        <IconButton
          component={RouterLink}
          to=".."
          color="primary"
          aria-label="Wróć do galerii raportów"
          sx={{ bgcolor: "rgba(13, 110, 253, 0.08)" }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: tint(report.color),
            color: report.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon />
        </Box>
        <Box>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 0.5 }}>
            <Chip label={report.category} size="small" variant="outlined" color="primary" />
          </Stack>
          <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
            {report.title}
          </Typography>
        </Box>
      </Stack>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 4, maxWidth: 900 }}>
        {report.description}
      </Typography>
    </>
  );
};

export default ReportHeader;
